import { type MaterializedItem } from 'modules/processes/domain'

export type MaterializedItemsFormValues = Partial<MaterializedItem> & {
  stepId: number | undefined
  accessIds?: number[]
  offset_direction?: string
  offset_amount?: number
  reference_field_key?: string
  assignee_strategy?: string
  location_id?: number
  team_ids?: number[]
  team_lead_team_ids?: number[]
}

export enum RoleTypes {
  MANAGER = 'manager',
}

export enum AssigneeStrategy {
  MANUAL_SELECTION = 'manual_selection',
  AFFECTED_USER = 'affected_user',
  MANAGER = RoleTypes.MANAGER,
  WORKSPACE = 'locations',
  TEAMS = 'teams',
  TEAM_LEADS = 'team_leads',
}
